import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ArrayHelper from 'foundation/array-helper';
import ScoringLoader, { endpointNames } from 'general/js/loaders/scoring-loader';
import { getCustomEventPlayerSitecoreData } from 'general/js/helpers';
import { BlockPlaceholder } from 'components/block-placeholder';
import { BlockSpinner } from 'components/block-spinner';
import CustomEventLeaderboardContainer from './custom-event-leaderboard-container';
import CustomEventLeaderboardAlphaList from './custom-event-leaderboard-alphalist';

class CustomEventLeaderboardLayout extends React.Component {
    componentDidMount() {
        const { customEventLeaderboardDatasource } = this.props.options;
        ScoringLoader.subscribe(customEventLeaderboardDatasource.leaderboardEndpoint.endpointName);
        ScoringLoader.subscribe(endpointNames.COURSE);
    }

    componentWillUnmount() {
        const { customEventLeaderboardDatasource } = this.props.options;
        ScoringLoader.unsubscribe(customEventLeaderboardDatasource.leaderboardEndpoint.endpointName);
        ScoringLoader.unsubscribe(endpointNames.COURSE);
    }

    render() {
        const {
            scoringLeaderboard,
            scoringCourse,
            options
        } = this.props;

        const { customEventLeaderboardPlayers } = this.props.options;

        if (scoringCourse === undefined ||
            scoringLeaderboard === undefined
        ) {
            return (
                <BlockPlaceholder minHeight={300}>
                    <BlockSpinner />
                </BlockPlaceholder>
            );
        }

        if (ArrayHelper.isEmpty(scoringLeaderboard.players)) {
            return <CustomEventLeaderboardAlphaList options={options} players={customEventLeaderboardPlayers} />;
        }

        return (
            <CustomEventLeaderboardContainer
                options={options}
                scoringCourse={scoringCourse}
                scoringLeaderboard={scoringLeaderboard}
            />
        );
    }
}

CustomEventLeaderboardLayout.propTypes = {
    options: PropTypes.object.isRequired
};

const mapStateToProps = (state, ownProps) => {
    const scoringLeaderboard = state.scoring[ownProps.options.customEventLeaderboardDatasource.leaderboardEndpoint.endpointName];

    if (scoringLeaderboard &&
        !ArrayHelper.isEmpty(scoringLeaderboard.players)
    ) {
        scoringLeaderboard.players.forEach((player) => {
            player.sitecoreData =
                getCustomEventPlayerSitecoreData(ownProps.options.customEventLeaderboardPlayers, player.id);
        });
    }

    return ({
        scoringCourse: state.scoring[endpointNames.COURSE],
        scoringLeaderboard,
    });
};

const CustomEventLeaderboardLayoutWrapper = connect(
    mapStateToProps,
    null
)(CustomEventLeaderboardLayout);

export default CustomEventLeaderboardLayoutWrapper;
